import { render, staticRenderFns } from "./tit.vue?vue&type=template&id=64f767d5&scoped=true"
import script from "./tit.vue?vue&type=script&lang=js"
export * from "./tit.vue?vue&type=script&lang=js"
import style0 from "./tit.vue?vue&type=style&index=0&id=64f767d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f767d5",
  null
  
)

export default component.exports